import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { DropDownFilter } from 'framework/list';
import { StatusTypes, StatusTypesLabels } from '../../ProjectStatusesService';

interface ProjectStatusTypeFilterProps extends DefaultDropdownProps {
  value?: string;
}

const ProjectStatusTypeFilter = (props: ProjectStatusTypeFilterProps) => {
  return (
    <DropDownFilter {...props}>
      <Dropdown
        {...props}
        placeholder="Select status type"
        options={[
          { value: StatusTypes.PLANNING, label: StatusTypesLabels.PLANNING },
          { value: StatusTypes.DEMO, label: StatusTypesLabels.DEMO },
        ]}
      />
    </DropDownFilter>
  );
};

export default ProjectStatusTypeFilter;
